import { render } from "./OrderDocumentCreateModal.vue?vue&type=template&id=b2e97e1e"
import script from "./OrderDocumentCreateModal.vue?vue&type=script&lang=js"
export * from "./OrderDocumentCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__